import { render, staticRenderFns } from "./CardSection.vue?vue&type=template&id=18093d14&scoped=true&"
import script from "./CardSection.vue?vue&type=script&lang=ts&"
export * from "./CardSection.vue?vue&type=script&lang=ts&"
import style0 from "./CardSection.vue?vue&type=style&index=0&id=18093d14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18093d14",
  null
  
)

export default component.exports